// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5CZW4","left":"styles_left__2f6Bb","desktopActions":"styles_desktopActions__ceONv","title":"styles_title__39nt2"};